function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Container, Label, ElementContainer, ElementWrapper } from './elements';
/**
 * Defines a Form Field component. It displays a field and its label.
 *
 * @return {jsx}
 */

var Field = /*#__PURE__*/function (_PureComponent) {
  _inherits(Field, _PureComponent);

  var _super = _createSuper(Field);

  function Field() {
    var _this;

    _classCallCheck(this, Field);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // Used to save whether inner component has focus or not.
      hasFocus: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        hasFocus: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        hasFocus: false
      }));
    });

    return _this;
  }

  _createClass(Field, [{
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this2 = this;

      var hasFocus = this.state.hasFocus;
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          isRow = _this$props.isRow,
          inlineLabel = _this$props.inlineLabel,
          labelWidth = _this$props.labelWidth,
          className = _this$props.className,
          size = _this$props.size;
      var injected = Children.map(children, function (child) {
        var displayName = child.type.displayName;
        var childProps = {
          _onFocus: _this2.handleFocus,
          _onBlur: _this2.handleBlur
        };

        if (displayName === 'Button') {
          childProps.type = 'submit';
        }

        return cloneElement(child, childProps);
      });
      return /*#__PURE__*/React.createElement(Wrapper, {
        isRow: isRow,
        size: size,
        className: className,
        "data-testid": "form-field"
      }, /*#__PURE__*/React.createElement(Container, {
        inlineLabel: inlineLabel
      }, label !== null && !(isRow == inlineLabel && label === '') && /*#__PURE__*/React.createElement(Label, {
        inlineLabel: inlineLabel,
        width: labelWidth,
        hasFocus: hasFocus
      }, label), /*#__PURE__*/React.createElement(ElementContainer, null, /*#__PURE__*/React.createElement(ElementWrapper, null, injected))));
    }
  }]);

  return Field;
}(PureComponent);
/** Display name. */


Field.displayName = 'Form.Field';
/** Prop types. */

Field.propTypes = {
  /**
   * Should be a Button, CheckBox, Input, Select, etc. Anything part of a form
   */
  children: PropTypes.node,

  /**
   * ClassName needed by styled components
   */
  className: PropTypes.string,

  /**
   * If label of the field is lined up with the input
   */
  inlineLabel: PropTypes.bool,

  /**
   * Makes sense if used with Form and Form.Group. If the Form.Group displays its fields
   * on the same row
   */
  isRow: PropTypes.bool,

  /**
   * Label of the field, displayed at the top or at the left of the input
   */
  label: PropTypes.string,

  /**
   * Width of the label (any value accepted by the css rule)
   */
  labelWidth: PropTypes.string,

  /**
   * Width of the field (any value accepted by the css rule)
   */
  size: PropTypes.string
};
/** Default props. */

Field.defaultProps = {
  children: null,
  className: '',
  inlineLabel: false,
  isRow: false,
  label: '',
  labelWidth: '10rem',
  size: '1'
};
export default Field;